import { createSelector } from 'reselect';
import keys from 'lodash/keys';
import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';

const allIds = (state) => state.entities.product.allIds;
const byId = (state) => state.entities.product.byId;

const productCategoriesById = (state) => state.entities.productCategory.byId;
const channelsById = (state) => state.entities.channel.byId;

export const getAllProducts = createSelector(
  [ byId, allIds ],
  (products, ids) => {
    return ids.map(id => products[id]);
  }
);

export const getProductsFilteredByScore = createSelector(
  [ getAllProducts ],
  (products) => {
    return orderBy(products, [
        product => product.periodInMonths,
        product => product.type,
      ], ['desc', 'desc']).filter(product => product.scoreEarned > 0);
  }
);

export const hasAnyProductsWithScore = createSelector(
  [getProductsFilteredByScore],
  (products) => products.length > 0
);

export const getAllProductsByChannel = createSelector(
  [ getAllProducts, productCategoriesById, channelsById ],
  (products, productCategories, channels) => {
    const groups = groupBy(products, product => product.channel);

    return keys(groups).map(key => {
      const channel = channels[key];
      const channelProducts = groups[key];
      const sortedChannelProducts = orderBy(channelProducts, [
        product => product.type,
        product => product.periodInMonths,
      ], ['desc', 'desc']);
      
      return {
        ...channel,
        products: sortedChannelProducts.map(product => {
          return {
            ...product,
            productCategory: productCategories[product.productCategory]
          };
        }),
      };
    });
  }
);


// WEBPACK FOOTER //
// ./src/modules/product/product.selectors.js